import LineIcon from "@assets/images/line.svg";
import RefreshIcon from "@assets/images/refresh-primary.svg";
import {
  Box,
  Button,
  Collapse,
  Divider,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup
} from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
// import InputSuggestion from "@saleor/alternatedMaterial/components/InputSuggestionForPrioridy";
import { FIELD_TYPE } from "@saleor/changeOrderExport/components/OrderFilterSection/constant";
import OrderStatus from "@saleor/changeOrderExport/components/OrderStatus";
import DatePicker from "@saleor/components/DatePicker";
import { FormSpacer } from "@saleor/components/FormSpacer";
import MultipleAutocompleteTextInput from "@saleor/components/MultipleAutocompleteTextInput";
import MyTypography from "@saleor/components/MyTypography";
import SingleSelectField from "@saleor/components/SingleSelectField";
import { SingleTextField } from "@saleor/components/SingleTextField";
import useOrderFilterConfirmation from "@saleor/hooks/useOrderFilterOrderConfirmationCustomer";
import {
  handleChangeCreateDateGte,
  handleChangeCreateDateLte
} from "@saleor/OrderConfirm/utils";
import { mapEdgesToItems } from "@saleor/utils/maps";
import cls from "classnames";
import moment from "moment-timezone";
import React, { useEffect, useMemo } from "react";
import SVG from "react-inlinesvg";
import { FormattedMessage } from "react-intl";

import useStyles from "./styles";

export interface IOrderListFilterProps {
  handleChangeFilter?: (filterObj: any) => void;
  message: JSX.Element | string;
  loading?: boolean;
  listOrder: any[];
}

const OrderFilterSectionCustomer: React.FC<IOrderListFilterProps> = ({
  handleChangeFilter,
  loading,
  message,
  listOrder
}) => {
  const classes = useStyles();
  // const [isFirstRender, setIsFirstRender] = useState<boolean>(false);
  // const [{ filterOrder: filterAppState }] = useAppState();
  const {
    formik,
    // setDataFormik,
    isOpen,
    setIsOpen,
    isClean,
    handleCleanForm,
    formData,
    ArrowIconComponent,
    getMaterialCustomerOrder,
    fetchMaterialCustomerOrder,
    loadingMaterialCustomerOrder
  } = useOrderFilterConfirmation({ handleChangeFilter });

  // if (filterAppState && !isFirstRender) {
  //   setDataFormik({
  //     ...filterAppState,
  //     gte: filterAppState.createDate
  //       ? filterAppState.createDate.gte
  //       : filterAppState.lastUpdate
  //       ? filterAppState.lastUpdate.gte
  //       : "",
  //     lte: filterAppState.createDate
  //       ? filterAppState.createDate.lte
  //       : filterAppState.lastUpdate
  //       ? filterAppState.lastUpdate.lte
  //       : "",
  //     dateSelectionType: filterAppState.createDate
  //       ? DateSelectionType.CREATE_DATE
  //       : DateSelectionType.LAST_UPDATE,
  //     statusSAP: filterAppState.statusSap?.length
  //       ? filterAppState.statusSap?.length === 1
  //         ? filterAppState.statusSap[0]
  //         : "ALL"
  //       : ""
  //   });
  //   setIsFirstRender(true);
  // }

  useEffect(() => {
    if (listOrder?.length && listOrder?.length > 0 && !loading) {
      setIsOpen(false);
    }
  }, [listOrder, loading]);

  const getTextError = field => (
    <div className={classes.textError}>{formik.errors[field]}</div>
  );

  const isDisabled = useMemo(
    () =>
      !(
        formik?.values?.poNo ||
        formik?.values?.soNo ||
        (formik?.values?.orderCreateDate?.gte &&
          formik?.values?.orderCreateDate?.lte)
      ),
    [
      formik?.values?.poNo,
      formik?.values?.soNo,
      formik?.values?.orderCreateDate?.gte,
      formik?.values?.orderCreateDate?.lte,
      formik.dirty
    ]
  );

  // const [] = useFilterSoldToDomesticOrderLazyQuery();
  const mappingDataSuggest = name => {
    if (name === "material") {
      const filterSoldToDomesticOrder =
        fetchMaterialCustomerOrder?.filterRequireAttentionMaterial;
      return {
        searchField: "material",
        getDataSuggestions: getMaterialCustomerOrder,
        loadingDataSuggestion: loadingMaterialCustomerOrder,
        isCheckingRole: true,
        dataOptions:
          mapEdgesToItems(filterSoldToDomesticOrder)?.map(data => ({
            title: `${data.code} - ${data.descriptionEn}`,
            value: `${data.code}`
          })) || []
      };
    }
  };

  const renderItem = (
    <Grid className={classes.searchBox} container spacing={3}>
      {formData.map((child, key) => {
        const renderChild = (children: JSX.Element) => (
          <Grid
            item
            md={
              child.type === FIELD_TYPE.DATEPICKER ||
              child.type === FIELD_TYPE.SUGGESTION_INPUT
                ? 6
                : 3
            }
            sm={
              child.type === FIELD_TYPE.DATEPICKER ||
              child.type === FIELD_TYPE.SUGGESTION_INPUT
                ? 12
                : 6
            }
            key={key}
            className={cls({
              [classes.gridDatePicker]: child.type === FIELD_TYPE.DATEPICKER
            })}
          >
            <div
              className={cls({
                [classes.boxDatePicker]: child.type === FIELD_TYPE.DATEPICKER
              })}
            >
              <MyTypography variant={"subtitle3"}>
                {child.title}
                {child.required && <span className={classes.required}>*</span>}
                {child?.subTitle ? (
                  <span className={classes.subTitle}>{child.subTitle}</span>
                ) : (
                  ""
                )}
              </MyTypography>
              {children}
              {child.type !== FIELD_TYPE.DATEPICKER
                ? getTextError(child.name)
                : ""}
            </div>
          </Grid>
        );
        if (child.type === FIELD_TYPE.EMPTY_DIV) {
          return renderChild(<div />);
        }
        if (child.type === FIELD_TYPE.MULTIPLE_SELECT) {
          return renderChild(
            <OrderStatus
              disableIndeterminate
              showChipDeleteButton={false}
              choices={child.options}
              name={child.name}
              id={child.name}
              value={formik.values[child.name]}
              onChange={formik.handleChange}
              showCircularIcon={false}
              isClean={isClean}
              placeholder={child.placeholder}
              listItemClass={classes.listItemClass}
              numberItemDisplay={2}
              error={!!formik.errors[child.name]}
            />
          );
        }
        if (child.type === FIELD_TYPE.SINGLE_DATE) {
          return renderChild(
            <DatePicker
              name={`${child.name}`}
              id={child.name}
              data-testid={child.name}
              disableManualInput
              value={formik.values[child.name]}
              onChange={formik.handleChange}
              format="YYYY-MM-DD"
            />
          );
        }
        if (child.type === FIELD_TYPE.SINGLE_INPUT) {
          return renderChild(
            <SingleTextField
              name={child.name}
              id={child.name}
              testId={child.name}
              value={formik.values[child.name]}
              onChange={formik.handleChange}
              placeholder={child.placeholder}
              disabled={child.disabled}
              error={!!formik.errors[child.name]}
              maxLengthProps={child?.maxLength ? child.maxLength : undefined}
            />
          );
        }
        if (child.type === FIELD_TYPE.SINGLE_SELECT) {
          return renderChild(
            <SingleSelectField
              className={classes.selectField}
              menuListCustomStyle={{
                overflowY: "auto"
              }}
              choices={child.options}
              name={child.name}
              id={child.name}
              testId={child.name}
              onChange={formik.handleChange}
              value={formik.values[child.name]}
              placeholder={child.placeholder}
              error={!!formik.errors[child.name]}
            />
          );
        }

        if (child.type === FIELD_TYPE.SUGGESTION_INPUT) {
          const dataSuggest = mappingDataSuggest(child.name);

          if (child.name === "material") {
            const dataSuggestMaterial = dataSuggest;
            return renderChild(
              <MultipleAutocompleteTextInput
                reRender={isClean}
                fullWidthItem
                maxCount={1}
                name={child.name}
                id={child.name}
                testId={child.name}
                getByValue
                keyFilterApi={"material"}
                isCheckingRole
                headerText={"Material Code / Description ที่เลือกค้นหา"}
                getDataSuggestions={dataSuggestMaterial.getDataSuggestions}
                // fetchDataSuggestions={dataSuggestMaterial.fetchDataSuggestions}
                loadingDataSuggestion={
                  dataSuggestMaterial.loadingDataSuggestion
                }
                dataOptions={dataSuggestMaterial.dataOptions}
                message={"ยังไม่มีข้อมูลที่เลือกค้นหา"}
                placeholder={"ค้นหา Material Code / Description"}
                handleSelectedSearch={value => {
                  formik.handleChange({
                    target: {
                      name: "material",
                      value
                    }
                  });
                }}
              />
            );
          }
          // dataSuggest must be 'material' only. Therefore, this will result in no data options being available and an error will occur
          // return renderChild(
          //   <InputSuggestion
          //     {...dataSuggest}
          //     // {...dataSuggest}
          //     contained
          //     key={`input${key}`}
          //     name={child.name}
          //     id={child.name}
          //     withNonSelect
          //     // searchField={child.name === "soldTo" ? "soldTo" : "material"}
          //     defaultInputValue={formik.values[child.name]}
          //     defaultValue={{
          //       title: formik.values[child.name],
          //       value: formik.values[child.name]
          //     }}
          //     objectSuggestion
          //     placeholder={child.placeholder}
          //     error={!!formik.errors[child.name]}
          //     isClean={isClean}
          //     handleSelectedSearch={e => {
          //       formik.handleChange({
          //         target: {
          //           name: child.name,
          //           value: typeof e === "string" ? e : e.value
          //         }
          //       });
          //     }}
          //   />
          // );
        }

        if (child.type === FIELD_TYPE.RADIO_GROUP) {
          return renderChild(
            <RadioGroup
              className={classes.radioGroup}
              aria-labelledby="demo-controlled-radio-buttons-group"
              name={child.name}
              id={child.name}
              data-testid={child.name}
              value={formik.values[child.name]}
              onChange={formik.handleChange}
            >
              {child.options?.map((o, oKey) => (
                <FormControlLabel
                  key={`radio${oKey}`}
                  value={o.value}
                  control={<Radio />}
                  label={
                    <MyTypography variant={"body3"}>{o.label}</MyTypography>
                  }
                />
              ))}
            </RadioGroup>
          );
        }
        if (child.type === FIELD_TYPE.DATEPICKER) {
          const maxPeriod = 89;
          return renderChild(
            <Box display={"flex"} justifyItems="center" alignItems={"start"}>
              <div className={classes.itemDatePicker}>
                <DatePicker
                  error={!!formik.errors[child.name]?.gte}
                  name={`${child.name}_gte`}
                  id={`${child.name}_gte`}
                  data-testid={`${child.name}_gte`}
                  disableManualInput
                  value={formik.values[child.name]?.gte || ""}
                  onChange={e =>
                    handleChangeCreateDateGte({
                      formik,
                      event: e,
                      maxPeriod,
                      child
                    })
                  }
                  format="YYYY-MM-DD"
                  maxDate={
                    formik.values[child.name].lte
                      ? moment(formik.values[child.name].lte)
                      : undefined
                  }
                  minDate={undefined}
                />
                <div className={classes.textError}>
                  {formik.errors.orderCreateDate?.gte}
                </div>
              </div>
              <Box px={1} className={classes.boxLine}>
                <SVG src={LineIcon} width={12} height={2} />
              </Box>
              <div className={classes.itemDatePicker}>
                <DatePicker
                  error={!!formik.errors[child.name]?.lte}
                  name={`${child.name}_lte`}
                  id={`${child.name}_lte`}
                  data-testid={`${child.name}_lte`}
                  disableManualInput
                  value={formik.values[child.name]?.lte || ""}
                  onChange={e => {
                    handleChangeCreateDateLte({
                      formik,
                      event: e,
                      maxPeriod,
                      child
                    });
                  }}
                  format="YYYY-MM-DD"
                  minDate={
                    formik.values[child.name].gte
                      ? moment(formik.values[child.name].gte)
                      : undefined
                  }
                  maxDate={undefined}
                />
                <div className={classes.textError}>
                  {formik.errors.orderCreateDate?.lte}
                </div>
              </div>
            </Box>
          );
        }
      })}
    </Grid>
  );

  return (
    <>
      <div className={classes.wrapper}>
        <Box className={classes.root}>
          <Grid
            className={classes.header}
            container
            onClick={() => setIsOpen(!isOpen)}
          >
            <MyTypography variant="h6">
              <FormattedMessage defaultMessage="ค้นหา Order Confirmation" />
            </MyTypography>
            <ArrowIconComponent className={classes.arrowIcon} />
          </Grid>
          <Collapse in={isOpen}>
            {renderItem}
            <Box className={classes.divider}>
              <FormSpacer />
              <Divider />
            </Box>
            <Box className={classes.bottomBar} ml={3}>
              <Box>{message}</Box>
              <Box className={classes.flex}>
                <Box mr={2}>
                  <Button
                    id={"resetButton"}
                    className={classes.resetButton}
                    variant={"outlined"}
                    color={"secondary"}
                    disabled={!formik.dirty}
                    onClick={handleCleanForm}
                  >
                    <SVG
                      src={RefreshIcon}
                      className={classes.icon}
                      width={16}
                      height={16}
                    />
                    <FormattedMessage defaultMessage="ล้างข้อมูล" />
                  </Button>
                </Box>
                <Box>
                  <Button
                    id={"submitForm"}
                    className={classes.actionButton}
                    variant={"contained"}
                    disabled={isDisabled || loading}
                    color={"secondary"}
                    onClick={formik.submitForm}
                  >
                    <SearchIcon style={{ fontSize: "18px" }} />
                    <FormattedMessage defaultMessage="ค้นหา" />
                  </Button>
                </Box>
              </Box>
            </Box>
          </Collapse>
        </Box>
      </div>
    </>
  );
};

export default OrderFilterSectionCustomer;
